
<script>
import { addMonths, format, isBefore, parseISO } from 'date-fns';
import { mapGetters, mapActions } from 'vuex';
import store from '@/store';
import router from '@/router';
import TiersApi from '@/api/tiers';
import InfosApi from '@/api/infos';
import { find } from 'lodash';

export default {
  name: 'Main',
  data: () => ({
    incident: null,
    showMenu: false,
    showMessage: false,
    versions: {
      front: 'loading...',
      back: 'loading...'
    },
    menuItems: [
      { libelle: 'Historique', route: 'main.catalog.order_history', icon: 'mdi-history', badge: false, bottomMenu: true },
      { libelle: 'Aliments', route: 'main.catalog.aliments', icon: '$vuetify.icons.aliment', badge: false, bottomMenu: true },
      { libelle: 'Lots & plans', route: 'main.catalog.lots', icon: '$vuetify.icons.chicken', badge: false, bottomMenu: true },
      { libelle: 'Contrats', route: 'main.catalog.contrats', icon: '$vuetify.icons.contrat', badge: false, bottomMenu: true },
      { libelle: 'Commandes internet', route: 'main.infos.commandesEnCours', icon: 'mdi-clipboard-text-outline', badge: false },
      { divider: true },
      { libelle: 'Gestion articles', route: 'main.admin.edit_articles', icon: 'mdi-cog', badge: false, role: 'COM_ALI_ECRITURE_ARTICLE' }
    ]
  }),

  beforeRouteEnter (to, from, next) {
    store.dispatch('user/loadUser')
      .then((user) => {
        if (~user.roles.indexOf('ADD_ALI_ADHERENT_VGM')) {
          router.push({ name: 'error-logout', query: { cause: 'ADHERENT_VGM' } });
          return;
        }

        if (!~user.roles.indexOf('COM_ALI_LECTURE_PERSONNELLE')) {
          if (!store.getters['user/connectedAs']) {
            router.push({ name: 'admin.connect_as.selection_tiers' });
            return;
          }
        }
        Promise.all([
          store.dispatch('referentiel/loadReferentiel', store.getters['user/numTiers']),
          store.dispatch('user/loadTiers')
        ]).then(
          () => next()
        ).catch(error => {
          let cause = null;
          try {
            if (error.response.data.code === 'TIERS_INEXISTANT') {
              cause = 'TIERS_NON_RECONNU';
            }
          } catch (e) { }
          router.push({ name: 'error-logout', query: { cause } });
        });
      })
      .catch(error => {
        if (error && error.response && error.response.status === 403) {
          router.push({ name: 'error-logout', query: { cause: 'ACCES_NON_AUTHORISE' } });
        } else {
          next(error);
        }
      });
  },
  computed: {
    currentRoute: {
      get () {
        return this.$route.name;
      }
    },
    ...mapGetters({
      user: 'user/user',
      tiers: 'user/tiers',
      numTiers: 'user/numTiers',
      cartSize: 'cart/nbLines',
      connectedAs: 'user/connectedAs',
      ref: 'referentiel/referentiel'
    }),
    filArianneParts: {
      get () {
        return this.$route.matched.filter(i => !!i.meta.title).map(r => ({ route: r.name, libelle: r.meta.title }));
      }
    },
    versionsTooltip () {
      return this.versions.front + ' > ' + this.versions.back;
    }
  },
  async created () {
    window.addEventListener('beforeunload', e => this.handler(e));

    this.versions.front = process.env.VUE_APP_VERSION;
    InfosApi.getVersion().then(
      version => { this.versions.back = version; },
      () => { this.versions.back = 'error'; }
    );

    this.$ga.set({ dimension1: this.user.username });
    this.$ga.set({ dimension2: this.user.username === this.numTiers ? 'TRUE' : 'FALSE' });

    const param = {
      typeTiers: this.tiers.typeTiers,
      numTiers: this.tiers.numTiers,
      numEntite: 'AGR'
    };

    if (this.ref.messagesBandeau.length !== 0) { this.showMessage = true; }

    await TiersApi.getIncidentPaiementTiers(param).then(incident => {
      this.incident = incident;
    });

    if (this.incident.bloquant === 'TRUE') {
      this.$dialog
        .confirm({ title: 'Contentieux', text: 'Un incident de paiement en cours vous empêche d’accéder au site de commandes d’aliments par internet. Pour toute information sur cet incident, veuillez contacter le responsable de comptes de votre maison de région.', actions: { true: { text: 'Fermer', flat: false, outlined: true } } });

      this.logout();
    }

    if (this.$route.name === 'main') {
      // TODO ? page par defaut selon tiers ?
      this.$router.push({ name: 'main.catalog.order_history' });
    }
  },
  methods: {
    ...mapActions({ sessionLogout: 'session/logout', resetTiers: 'user/resetTiers', resetConnectedAs: 'user/resetConnectedAs', loadContrats: 'contrats/loadContrats' }),
    getContratsTiers () {
      const param = {
        typeTiers: this.tiers.typeTiers,
        numTiers: this.tiers.numTiers,
        numEntite: 'AGR',
        dateValidite: format(new Date(), 'yyyy-MM-dd')
      };

      this.loadContrats(param).then(contrats => {
        for (const contrat of contrats) {
          const alerte = isBefore(parseISO(contrat.dateFin), addMonths(Date.now(), 1)) && contrat.qteRestante > 0;
          if (alerte) {
            find(this.menuItems, { route: 'main.catalog.contrats' }).badge = true;
            return;
          }
        }
      });
    },
    handler (event) {
      if (this.cartSize) {
        var message = 'Voulez vous sortir ?';
        /* InternetExplorer/Firefox */
        var e = event || window.event;
        e.returnValue = message;
        /* WebKit browser */
        return message;
      }
    },
    logout () {
      if (this.connectedAs) {
        this.$store.dispatch('reset');
        this.$router.push({ name: 'admin.connect_as.selection_tiers' });
        return;
      }

      this.sessionLogout().finally(() => {
        this.$ga.event({
          eventCategory: 'session',
          eventAction: 'logout',
          eventLabel: this.tiers.numTiers
        });

        this.$store.dispatch('reset');
        this.$router.push({ name: 'login' });
      });
    },
    logoutWithConfirmation () {
      if (this.cartSize) {
        this.$dialog.confirm({
          title: 'Déconnexion',
          text: 'Vous avez un ou plusieurs articles en attente de validation définitive dans votre panier.<br> Si vous quittez la saisie de votre commande, le contenu du panier sera perdu.',
          actions: {
            true: {
              text: 'Abandonner la saisie',
              flat: false,
              outlined: true
            },
            false: {
              text: 'Continuer la saisie',
              flat: false
            }
          }
        }).then(confirm => {
          if (confirm) {
            this.logout();
          }
        });
      } else {
        this.logout();
      }
    },
    goMonAgrial () {
      this.loading = true;
      InfosApi.getUrlPortail().then(url => {
        window.location.href = url;
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};

</script>

<template>
  <div class="screen-size page-container">
    <Menu
      :show.sync="showMenu"
      :items="menuItems"
      :afficher-lien-agrial="isMobile"
    />
    <div
      v-if="!isMobile"
      class="left-spacer"
    />
    <div>
      <v-app-bar
        fixed
        app
      >
        <div class="menu-btn-container primary">
          <v-icon
            color="white"
            large
            @click="showMenu = true"
          >
            mdi-menu
          </v-icon>
        </div>
        <img
          v-if="isMobile"
          src="../../assets/images/logo_cdea_mobile.png"
          alt="Agrial"
          style="height:60%;width:auto;"
          :title="versionsTooltip"
        >
        <img
          v-else
          src="../../assets/images/logo_cdea.png"
          alt="Agrial"
          style="height:60%;width:auto;"
          :title="versionsTooltip"
        >
        <div
          v-if="!isMobile"
          class="ariane ml-4"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                v-bind="attrs"
                @click="goMonAgrial()"
                v-on="on"
              >
                mdi-home
              </v-icon>
            </template>
            <span>Mon Agrial</span>
          </v-tooltip>
          <span
            v-for="part in filArianneParts"
            :key="part.route"
          >
            &nbsp;/&nbsp;
            <router-link :to="{name:part.route}">{{ part.libelle }}</router-link>
          </span>
        </div>
        <!--<span>{{ currentRoute }}</span>-->
        <!-- TODO : remove -->
        <div class="flex-fill" />
        <v-chip
          v-if="!isMobile"
          color="#f6eee1"
          text-color="secondary"
        >
          {{ tiers.raisonSociale }}
        </v-chip>
        <v-btn
          icon
          color="secondary"
          @click="$router.push({name:'main.catalog.cart.view'})"
        >
          <v-badge
            :content="cartSize"
            :value="cartSize"
            color="secondary"
            offset-x="10px"
            offset-y="10px"
          >
            <v-icon
              color="secondary"
              size="2.1em"
            >
              mdi-cart-outline
            </v-icon>
          </v-badge>
        </v-btn>
        <v-btn
          icon
          color="secondary"
          @click="logoutWithConfirmation()"
        >
          <v-icon>mdi-power</v-icon>
        </v-btn>

        <div style="width:15px;" />
      </v-app-bar>

      <v-main class="app-content">
        <div
          v-if="showMessage"
          class="bandeau"
        >
          <v-card>
            <v-card-text class="bandeau_text warning white--text">
              <div
                v-for="(bandeau, i) in ref.messagesBandeau"
                :key="i"
              >
                <i>
                  <h2>
                    <v-icon color="white">
                      mdi-alert-outline
                    </v-icon> {{ bandeau }}
                  </h2>
                </i>
              </div>
            </v-card-text>
          </v-card>
        </div>
        <router-view />
        <v-footer>
          <div class="footer">
            <div class="footer-logo">
              <img
                src="../../assets/images/logo_cdea.png"
                alt="Agrial"
              >
            </div>
            <div>
              <div>
                <router-link :to="{name:'main.infos.conditionsVente'}">
                  CGU
                </router-link>
              </div>
              <div>
                <router-link :to="{name:'main.infos.mention'}">
                  Mentions légales
                </router-link>
              </div>
              <div>
                <router-link :to="{name:'main.infos.politiqueConfidentialite'}">
                  Politique de confidentialité
                </router-link>
              </div>
            </div>
            <div>
              <router-link :to="{name:'main.infos.contacts'}">
                Contacts
              </router-link>
            </div>
          </div>
        </v-footer>
      </v-main>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-container {
  display: flex;
  flex-direction: row;
  & > * {
    flex-grow: 1;
    max-width: 100%;
  }
}
.left-spacer {
  min-width: 70px;
  width: 70px;
  flex-grow: 0;
}
.v-toolbar ::v-deep .v-toolbar__content {
  padding: 0 !important;
}

.menu-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 56px;
  margin-right: 20px;
}

.bandeau {
  margin: 1em 2vw 0 2vw;
}

.app-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-image: url("../../assets/images/bg-content.png");
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: auto 60%;
}

.footer {
  font-size: 0.9em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  height: 120px;
  width: 100%;
  & > * {
    margin: 1.5em 3vw;
  }
  * {
    white-space: nowrap;
    max-height: 100%;
  }
  img {
    max-height: 50px;
    max-width: 23vw;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .footer {
    display: block;
    position: relative;
    text-align: right;
    margin-bottom: 50px;

    .footer-logo {
      position: absolute;
      top: 0;
      left: 0;
    }
    & > * {
      margin: 10px 2em;
    }
    * {
      text-align: right;
    }
  }

  .bandeau {
    margin: 0;

    .bandeau_text {
      padding: 10px;
    }
  }
}
</style>
